/* © CNES */
import { Zoom } from 'ol/control';
import { useContext, useEffect } from 'react';
import { ConfigContext } from '../../../../context/ConfigContext';
import MapContext from '../../MapContext';
import './ZoomControl.scss';

/**
 * Zoom Control.
 * @returns null
 */
const ZoomControl = () => {
  const { map } = useContext(MapContext);
  const context = useContext(ConfigContext);

  /**
   * Display options to zoom on map.
   */
  useEffect(() => {
    if (!map) return;
    let zoomControl = new Zoom({});
    if (context.isLeftSidePanelShown) {
      zoomControl = new Zoom({ className: 'zoom-control out' });
    }

    map.addControl(zoomControl);

    return () => {
      map.removeControl(zoomControl);
    };
  }, [map, context]);
  return null;
};
export default ZoomControl;
